// extracted by mini-css-extract-plugin
export default {"root":"FormGridTemplate_root__-sLv-","placeHolderShimmer":"FormGridTemplate_placeHolderShimmer__XGRgH"};